'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = debug('libp2p:webrtc-star');

var multiaddr = require('multiaddr');

var mafmt = require('mafmt');

var withIs = require('class-is');

var io = require('socket.io-client');

var EE = require('events').EventEmitter;

var SimplePeer = require('simple-peer');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var Connection = require('interface-connection').Connection;

var toPull = require('stream-to-pull-stream');

var once = require('once');

var setImmediate = require('async/setImmediate');

var webrtcSupport = require('webrtcsupport');

var utils = require('./utils');

var cleanUrlSIO = utils.cleanUrlSIO;
var cleanMultiaddr = utils.cleanMultiaddr;
var noop = once(function () {});
var sioOptions = {
  transports: ['websocket'],
  'force new connection': true
};

var WebRTCStar =
/*#__PURE__*/
function () {
  function WebRTCStar(options) {
    _classCallCheck(this, WebRTCStar);

    options = options || {};
    this.maSelf = undefined;
    this.sioOptions = {
      transports: ['websocket'],
      'force new connection': true
    };

    if (options.wrtc) {
      this.wrtc = options.wrtc;
    }

    this.discovery = new EE();
    this.discovery.tag = 'webRTCStar';

    this.discovery.start = function (callback) {
      setImmediate(callback);
    };

    this.discovery.stop = function (callback) {
      setImmediate(callback);
    };

    this.listenersRefs = {};
    this._peerDiscovered = this._peerDiscovered.bind(this);
  }

  _createClass(WebRTCStar, [{
    key: "dial",
    value: function dial(ma, options, callback) {
      var _this = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = callback ? once(callback) : noop;
      var intentId = (~~(Math.random() * 1e9)).toString(36) + Date.now();
      var sioClient = this.listenersRefs[Object.keys(this.listenersRefs)[0]].io;
      var spOptions = {
        initiator: true,
        trickle: false // Use custom WebRTC implementation

      };

      if (this.wrtc) {
        spOptions.wrtc = this.wrtc;
      }

      var channel;

      try {
        channel = new SimplePeer(spOptions);
      } catch (err) {
        log('Could not create connection:', err);
        return callback(err);
      }

      var conn = new Connection(toPull.duplex(channel));
      var connected = false;
      channel.on('signal', function (signal) {
        sioClient.emit('ss-handshake', {
          intentId: intentId,
          srcMultiaddr: _this.maSelf.toString(),
          dstMultiaddr: ma.toString(),
          signal: signal
        });
      });
      channel.once('timeout', function () {
        return callback(new Error('timeout'));
      });
      channel.once('error', function (err) {
        if (!connected) {
          callback(err);
        }
      }); // NOTE: aegir segfaults if we do .once on the socket.io event emitter and we
      // are clueless as to why.

      sioClient.on('ws-handshake', function (offer) {
        if (offer.intentId === intentId && offer.err) {
          return callback(new Error(offer.err));
        }

        if (offer.intentId !== intentId || !offer.answer) {
          return;
        }

        channel.once('connect', function () {
          connected = true;
          conn.destroy = channel.destroy.bind(channel);
          channel.once('close', function () {
            return conn.destroy();
          });

          conn.getObservedAddrs = function (callback) {
            return callback(null, [ma]);
          };

          callback(null, conn);
        });
        channel.signal(offer.signal);
      });
      return conn;
    }
  }, {
    key: "createListener",
    value: function createListener(options, handler) {
      var _this2 = this;

      if (typeof options === 'function') {
        handler = options;
        options = {};
      }

      var listener = new EE();

      listener.listen = function (ma, callback) {
        callback = callback ? once(callback) : noop;

        if (!webrtcSupport.support && !_this2.wrtc) {
          return setImmediate(function () {
            return callback(new Error('no WebRTC support'));
          });
        }

        _this2.maSelf = ma;
        var sioUrl = cleanUrlSIO(ma);
        log('Dialing to Signalling Server on: ' + sioUrl);
        listener.io = io.connect(sioUrl, sioOptions);
        listener.io.once('connect_error', callback);
        listener.io.once('error', function (err) {
          listener.emit('error', err);
          listener.emit('close');
        });
        listener.io.on('ws-handshake', incommingDial);
        listener.io.on('ws-peer', _this2._peerDiscovered);
        listener.io.on('connect', function () {
          listener.io.emit('ss-join', ma.toString());
        });
        listener.io.once('connect', function () {
          listener.emit('listening');
          callback();
        });
        var self = _this2;

        function incommingDial(offer) {
          if (offer.answer || offer.err) {
            return;
          }

          var spOptions = {
            trickle: false // Use custom WebRTC implementation

          };

          if (self.wrtc) {
            spOptions.wrtc = self.wrtc;
          }

          var channel;

          try {
            channel = new SimplePeer(spOptions);
          } catch (err) {
            log('Could not create incoming connection:', err);
            return callback(err);
          }

          var conn = new Connection(toPull.duplex(channel));
          channel.once('connect', function () {
            conn.getObservedAddrs = function (callback) {
              return callback(null, [offer.srcMultiaddr]);
            };

            listener.emit('connection', conn);
            handler(conn);
          });
          channel.once('signal', function (signal) {
            offer.signal = signal;
            offer.answer = true;
            listener.io.emit('ss-handshake', offer);
          });
          channel.signal(offer.signal);
        }
      };

      listener.close = function (callback) {
        callback = callback ? once(callback) : noop;
        listener.io.emit('ss-leave');
        setImmediate(function () {
          listener.emit('close');
          callback();
        });
      };

      listener.getAddrs = function (callback) {
        setImmediate(function () {
          return callback(null, [_this2.maSelf]);
        });
      };

      this.listenersRefs[multiaddr.toString()] = listener;
      return listener;
    }
  }, {
    key: "filter",
    value: function filter(multiaddrs) {
      if (!Array.isArray(multiaddrs)) {
        multiaddrs = [multiaddrs];
      }

      return multiaddrs.filter(function (ma) {
        if (ma.protoNames().indexOf('p2p-circuit') > -1) {
          return false;
        }

        return mafmt.WebRTCStar.matches(ma);
      });
    }
  }, {
    key: "_peerDiscovered",
    value: function _peerDiscovered(maStr) {
      log('Peer Discovered:', maStr);
      maStr = cleanMultiaddr(maStr);
      var split = maStr.split('/ipfs/');
      var peerIdStr = split[split.length - 1];
      var peerId = PeerId.createFromB58String(peerIdStr);
      var peerInfo = new PeerInfo(peerId);
      peerInfo.multiaddrs.add(multiaddr(maStr));
      this.discovery.emit('peer', peerInfo);
    }
  }]);

  return WebRTCStar;
}();

module.exports = withIs(WebRTCStar, {
  className: 'WebRTCStar',
  symbolName: '@libp2p/js-libp2p-webrtc-star/webrtcstar'
});